var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"asc-descriptions-item"},[_c('span',{staticClass:"asc-descriptions-item--label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('span',{staticClass:"asc-descriptions-item--content"},[_vm._v(_vm._s(_vm.value))])])])}
var staticRenderFns = []

export { render, staticRenderFns }